import {
    Component,
    InputSignal,
    Signal,
    WritableSignal,
    computed,
    input,
    signal,
    OnDestroy,
    output
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatIconModule } from '@angular/material/icon';
import { DatiqTemplateModule } from '@dat/datiq-components-pkg/template';

@Component({
    selector: 'iq-tooltip-tooltip',
    standalone: true,
    imports: [CommonModule, MatIconModule, OverlayModule, DatiqTemplateModule],
    templateUrl: './iq-tooltip-tooltip.component.html',
    styleUrl: './iq-tooltip-tooltip.component.scss',
})
export class IqTooltipTooltipComponent implements OnDestroy {
    id: InputSignal<string> = input('');
    label: InputSignal<string> = input('');
    tooltipBody: InputSignal<string> = input('');
    tooltipHeader: InputSignal<string> = input('');
    openOnClick: InputSignal<boolean> = input(false);

    isOpen: WritableSignal<boolean> = signal(false);
    isMouseOverLabel: WritableSignal<boolean> = signal(false);
    isMouseOverTooltip: WritableSignal<boolean> = signal(false);
    tooltipCloseTimer: any = null;

    showHeader: Signal<boolean> = computed(() => {
        return !!this.tooltipHeader()?.length;
    });

    clickedTooltip = output()
    hoveredTooltip = output();

    toggle() {
        const isOpen = this.isOpen();

        if (this.openOnClick()) {
            this.isOpen.set(!isOpen);
        }
    }

    close() {
        this.isOpen.set(false);
    }

    handleMouseEnter() {
        this.isMouseOverLabel.set(true);
        this.clearCloseTimer();
        this.isOpen.set(true);
        this.hoveredTooltip.emit();
    }

    handleMouseLeave() {
        this.isMouseOverLabel.set(false);
        this.setCloseTimer();
    }

    handleTooltipMouseEnter() {
        this.isMouseOverTooltip.set(true);
        this.clearCloseTimer();
    }

    handleTooltipMouseLeave() {
        this.isMouseOverTooltip.set(false);
        this.setCloseTimer();
    }

    setCloseTimer() {
        this.tooltipCloseTimer = setTimeout(() => {
            if (!this.isMouseOverLabel() && !this.isMouseOverTooltip()) {
                this.isOpen.set(false);
            }
        }, 150); // 150ms delay gives user time to move between elements
    }

    clearCloseTimer() {
        if (this.tooltipCloseTimer) {
            clearTimeout(this.tooltipCloseTimer);
            this.tooltipCloseTimer = null;
        }
    }

    handleTooltipClick() {
        this.clickedTooltip.emit();
    }

    ngOnDestroy() {
        this.clearCloseTimer();
    }
}